import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuGroupPage } from "./pages/menu-group-page";
import { MenuItemPage } from "./pages/menu-item-page";
import { CheckoutPage } from "./pages/checkout/checkout";
import { AddressEntryPage } from "./pages/address-entry/address-entry";
import { OrderSuccessPage } from "./pages/order-success/order-success";
import { PaymentCancelPage } from "./pages/payment-cancel/payment-cancel";
import { PaypalCancelPage } from "./pages/paypal-cancel/paypal-cancel";
import { SearchPage } from "./pages/search/search";
import { ChooseMethodPage } from "./pages/choose-method/choose-method";
import { PaymentPage } from "./pages/payment/payment";
import { ChooseTimePage } from "./pages/choose-time/choose-time";
import { SubmitErrorPage } from "./pages/submit-error";
import { SelectBenefitPage } from "./pages/select-benefit";
import { EnterCodePage } from "./pages/enter-code";
import { DemoSuccessPage } from "./pages/demo-success";
import { ServicecallSuccessPage } from "./pages/servicecall-success";


const routes: Routes = [
  { path: '', component: MenuGroupPage },
  { path: 'grp/:grpid', component: MenuGroupPage },
  { path: 'item/:itemid', component: MenuItemPage },
  { path: 'search', component: SearchPage },
  { path: 'checkout/start', component: CheckoutPage },
  { path: 'checkout', component: CheckoutPage },
  { path: 'checkout/method', component: ChooseMethodPage },
  { path: 'checkout/contact', component: AddressEntryPage },
  { path: 'checkout/time', component: ChooseTimePage },
  { path: 'checkout/payment', component: PaymentPage },
  { path: 'checkout/select-benefit', component: SelectBenefitPage},
  { path: 'checkout/code', component: EnterCodePage},
  { path: 'cash/:orderid/success', component: OrderSuccessPage },
  { path: 'demo/success', component: DemoSuccessPage },
  { path: 'service/success', component: ServicecallSuccessPage },
  { path: 'order/:orderid/success', component: OrderSuccessPage },
  { path: 'order/:orderid/cancel', component: PaymentCancelPage },
  { path: 'paypal/:orderid/success', component: OrderSuccessPage },
  { path: 'paypal/:orderid/cancel', component: PaypalCancelPage },
  { path: 'error', component: SubmitErrorPage },
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
